(function() {
  function initAccordionIcons() {
    const accordionHeaders = document.querySelectorAll('[data-accordion-trigger]');
    
    accordionHeaders.forEach(function(header) {
      if (header.querySelector('.accordion-icon')) return;
      
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'accordion-icon');
      svg.setAttribute('width', '16');
      svg.setAttribute('height', '16');
      svg.setAttribute('viewBox', '0 0 16 16');
      svg.setAttribute('fill', 'none');
      
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M4 6L8 10L12 6');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '2');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      
      svg.appendChild(path);
      header.appendChild(svg);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordionIcons);
  } else {
    initAccordionIcons();
  }
  
  document.addEventListener('click', function(e) {
    
    const trigger = e.target.closest('[data-accordion-trigger]');
    
    if (!trigger) return;

    const accordion = trigger.closest('[data-accordion]');
    
    if (!accordion) return;

    const content = accordion.querySelector('.accordion-content');
    
    if (!content) return;

    if (!trigger.hasAttribute('aria-expanded')) {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-expanded', 'false');
      
      const contentId = `accordion-content-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      content.setAttribute('id', contentId);
      trigger.setAttribute('aria-controls', contentId);
      content.setAttribute('aria-hidden', 'true');
    }

    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    
    trigger.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
    content.setAttribute('aria-hidden', !isExpanded ? 'false' : 'true');
    accordion.classList.toggle('is-open');
    
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;

    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;

    e.preventDefault();
    trigger.click();
  });

})();